module.exports = __webpack_public_path__ + "media/images/help/company/mv-company-03-c97b035006e8404fb5857cb41cee2703.jpg";